var map = {
	"./about.png": "4c32",
	"./active.png": "5e9f",
	"./ada.png": "c244",
	"./amount.png": "93ef",
	"./approved.png": "7fc5",
	"./arrow-white.png": "5d91",
	"./arrow.png": "061e",
	"./balance.png": "0d11",
	"./bnb.png": "713c",
	"./btc.png": "c6d6",
	"./busd.png": "55d6",
	"./camera.png": "5e4f",
	"./cancelled.png": "5799",
	"./chart.png": "7d0f",
	"./close.png": "d991",
	"./confirmed.png": "2a75",
	"./copy.png": "8c7b",
	"./crystal.png": "2155",
	"./danger.png": "b57f",
	"./dashboard.png": "a623",
	"./date.png": "be24",
	"./decline.png": "adfe",
	"./doge.png": "5aed",
	"./done.png": "9cda",
	"./earth-mobile.png": "c4ab",
	"./earth.png": "6e18",
	"./eth.png": "88f6",
	"./facebook.png": "5b2d",
	"./finished.png": "9e79",
	"./fortchain-mini.png": "d4cf",
	"./fortchain.png": "9c5a",
	"./fortchain_full.png": "1125",
	"./fortchain_new.png": "f755",
	"./game.png": "acc1",
	"./holding.png": "704a",
	"./instagram.png": "cda7",
	"./loading.png": "cfcf",
	"./locked.png": "bf52",
	"./log_out.png": "2618",
	"./money-bag.png": "fce9",
	"./name.png": "b0a6",
	"./origination.png": "107a",
	"./pending.png": "1a0d",
	"./question.png": "4227",
	"./radiation_clock.png": "7e12",
	"./receive.png": "6db5",
	"./rocket.png": "8cbf",
	"./sand-clock.png": "2a47",
	"./select_arrow.png": "3eda",
	"./setting.png": "abf7",
	"./settings.png": "9d6a",
	"./sol.png": "ddaf",
	"./stake.png": "13f7",
	"./staking.png": "9d16",
	"./status.png": "70b9",
	"./telegram.png": "e314",
	"./titlt_arrow_down.png": "411e",
	"./titlt_arrow_up.png": "16c2",
	"./transfer.png": "369a",
	"./tvl.png": "140c",
	"./twitter.png": "9284",
	"./usd.png": "8e88",
	"./usdc.png": "6f85",
	"./usdt.png": "728d",
	"./user.png": "ba97",
	"./vector.png": "e3fb",
	"./vector2.png": "1f68",
	"./vector3.png": "93fc",
	"./vectors.png": "7a19",
	"./wallet.png": "a3e7",
	"./wallet_circle.png": "9ea6",
	"./wallet_token.png": "c010",
	"./withdraw.png": "443e",
	"./withdraw_about.png": "9be5",
	"./withdrawal.png": "9e18",
	"./withdrawn.png": "4d57",
	"./xrp.png": "f8a4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";